import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=221b72f6&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b72f6",
  null
  
)

export default component.exports